import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import {
	type SubmissionAction,
	type SubmissionStatus,
} from '@/classes/SubmissionStatuses/types'

export class ManuallyResolvedStatus implements StatusObject {
	vendorName: string
	submissionStatus: SubmissionStatus

	constructor(submissionStatus: SubmissionStatus, vendorName: string) {
		this.submissionStatus = submissionStatus
		this.vendorName = vendorName
	}

	getVendorName(): string {
		return this.vendorName
	}

	getUpdatedAt() {
		return this.submissionStatus.updatedAt
	}

	getActions(): Array<SubmissionAction> {
		return []
	}

	getStatusText() {
		return 'Manually Resolved'
	}

	getToolTipText() {
		return {
			title: this.getStatusText(),
			body:
				'This ' +
				this.getVendorName() +
				' submission has been manually resolved. Have questions? Please contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.SUCCESS
	}
}
